export const createArr = (length = 3) =>
  Array.from({ length }, (v, i) => ({ id: i + 1 }))
